import { type SuggestedProject } from '@littlebird/sdk';
import { useEffect } from 'react';

import { projectSuggestionEventProps } from '@/features/projects/project-suggestion-analytics';
import { trackEvent } from '@/utils/analytics';

const reportedSuggestionKeys = new Set<string>();

export function useTrackProjectSuggestionShown(
  chatId: string,
  suggestion: SuggestedProject | null
) {
  useEffect(() => {
    if (!suggestion) return;

    const reportIfVisible = () => {
      if (document.visibilityState !== 'visible') return;

      const key = JSON.stringify([
        chatId,
        suggestion.projectId,
        suggestion.name,
      ]);
      if (reportedSuggestionKeys.has(key)) return;
      reportedSuggestionKeys.add(key);

      trackEvent(
        'PROJECT_SUGGESTION_SHOWN',
        projectSuggestionEventProps(suggestion)
      );
    };

    reportIfVisible();
    document.addEventListener('visibilitychange', reportIfVisible);
    return () =>
      document.removeEventListener('visibilitychange', reportIfVisible);
  }, [chatId, suggestion]);
}
